import { Descriptions, Space, Button } from "antd";
import { getFormattedDateWithDay } from "../../../utils/datesUtils";
import { useStore } from "../../../config/store";
import { categoryToAccusative } from "../../../utils";
import dayjs from "dayjs";

export const Info = () => {
  const { clean, error, settings, closeDrawer, setDrawer, changeClean } = useStore();

  if (!clean) return null;

  const { date, cleantime, object, type, cost, rent, comment, rentAfter, plan_time, status } = clean;
  const isTodayOrBeforeClean = dayjs(date).isSame(dayjs(), 'day') || dayjs(date).isBefore(dayjs(), 'day');

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%", padding: '0 12px 12px 12px' }}>
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Дата">{getFormattedDateWithDay(date)}</Descriptions.Item>
        <Descriptions.Item label="Время">
          <Space>
            <span>{plan_time || cleantime || ""}</span>
            {rentAfter && <span className="red">заезд</span>}
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="Адрес">{object.address}</Descriptions.Item>
        <Descriptions.Item label="Уборка">{type}</Descriptions.Item>
        <Descriptions.Item label="Оплата">{cost}</Descriptions.Item>
        {comment?.length > 0 && (
          <Descriptions.Item label="Комментарий">{comment}</Descriptions.Item>
        )}
        {rent?.guests && (
          <Descriptions.Item label="Гостей было">
            {`${rent.guests} гостей${rent.adults ? `, взрослых ${rent.adults}` : ""}${rent.children ? `, детей ${rent.children}` : ""}`}
          </Descriptions.Item>
        )}
        {rentAfter?.guests && (
          <Descriptions.Item label="Гостей будет">
            {`${rentAfter.guests} гостей${rentAfter.adults ? `, взрослых ${rentAfter.adults}` : ""}${rentAfter.children ? `, детей ${rentAfter.children}` : ""}`}
          </Descriptions.Item>
        )}
        {(isTodayOrBeforeClean && object?.wifi) ? (
          <Descriptions.Item label="Wi-Fi">
            {object.wifi}
          </Descriptions.Item>
        ) : null}
      </Descriptions>
      <Space direction="vertical" style={{ width: "100%" }}>
        {error && <div className="error">{error}</div>}
        {["start", "accept"].includes(status) && <Button block onClick={() => setDrawer("howin")} size="large">
          Как попасть в {categoryToAccusative(object.category)}
        </Button>}
        {object?.instructions && (
          <Button block onClick={() => setDrawer("instruction")} size="large">
            Инструкция по уборке
          </Button>
        )}
        {["no", "refusal"].includes(status) && (
          <Button type="primary" block onClick={() => changeClean({ status: "accept" })} size="large">
            Принять заявку
          </Button>
        )}
        {isTodayOrBeforeClean && !["start", "finish", "finish_without_photo", "no", "refusal"].includes(status) && (
          <Button type="primary" block onClick={() => changeClean({ status: "start" })} size="large">
            Начать уборку
          </Button>
        )}
        {isTodayOrBeforeClean && ["start", "finish", "finish_without_photo"].includes(status) && (
          <>
            {settings?.keylock && (
              <Button variant="outlined" block onClick={() => setDrawer("code")} size="large">
                🔐 Установить новый код
              </Button>
            )}
            <Button variant="outlined" block onClick={() => setDrawer("comment")} size="large">
              📝 Написать комментарий
            </Button>
            <Button variant="outlined" block onClick={() => setDrawer("buy")} size="large">
              🛒 Что нужно купить
            </Button>
            <Button variant="outlined" block onClick={() => setDrawer("fix")} size="large">
              ⚙️ Что сломалось
            </Button>
            {object.meters_requested &&
              <Button variant="outlined" block color="danger" onClick={() => setDrawer("meters")} size="large">
                ⏲️ Внести показания
              </Button>}
          </>
        )}
        {!["start", "finish", "finish_without_photo", "refusal"].includes(status) && (
          <Button block onClick={() => setDrawer("refuse")} size="large" color="danger" variant="outlined">
            Отказаться
          </Button>
        )}
        {status === "start" && (
          <Button block onClick={() => setDrawer("finish")} size="large" type="primary">
            ✅ Закончить уборку
          </Button>
        )}
        {status === "finish_without_photo" && (
          <Button block onClick={() => setDrawer("upload")} size="large" type="primary">
            📸 Загрузить фото
          </Button>
        )}
        <Button block onClick={closeDrawer} size="large">
          Закрыть
        </Button>
      </Space>
    </Space>
  );
};
